import React from 'react';
import styles from './style.module.css';
import StepSevenForm from '../../components/forms/step-seven';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Money In</p>
        <h2 className={styles.mainTitle}>What I receive</h2>
        <StepSevenForm/>
    </div>
);
